import Image from 'next/image';
import styles from './overview.module.css';
import React from 'react';

const ranges = {
	c: {
		c1: '15.5%',
		c2: '18%',
		c3: '20%',
		c4: '22%',
		c5: '24%',
		c6: '26%',
		c7: '28%',
		c8: '30%',
	},
	t: {
		t1: '30.7%',
		t2: '32.5%',
		t3: '35%',
		t4: '38%',
		t5: '40%',
		t6: '43%',
		t7: '45.5%',
		t8: '48.5%',
		t9: '51.5%',
		t10: '54.5%',
		t11: '57.5%',
		t12: '61%',
	},
	l: {
		l1: '63.5%',
		l2: '67%',
		l3: '71.5%',
		l4: '75%',
		l5: '79.5%',
	},
	s: {
		s1: '82%',
		s2: '84.5%',
		s3: '87%',
		s4: '89.5%',
		s5: '92%',
	},
};

function getPercentage(level: string): string {
	const key = level.toLowerCase();
	const group = key[0] as keyof typeof ranges;

	return (ranges[group] as any)[key] || null;
}

export default function LevelsImage({ levels }: { levels: string }) {
	let sections: ({ single: string } | { from: string; to: string })[] = [];
	if (levels && levels !== 'unknown') {
		const trims = levels.split(', ').map((s) => s.trim());
		for (const trim of trims) {
			if (trim.includes('-')) {	
				const [from, to] = trim.split('-').map((s) => s.trim());
				sections.push({ from, to });
			} else {
				sections.push({ single: trim });
			}
		}
	}

	return (
		<div className={styles['whoCanTakePart-img']}>
			<Image
				src='/injuries/spinal-cord-levels.png'
				alt='Spinal Cord Levels'
				width={494}
				height={600}
				// width={272}
				// height={300}
			/>

			{sections.map((section, i) => {
				if ('single' in section) {
					return (
						<React.Fragment key={i}>
							<div
								className={styles.single}
								style={{
									top: getPercentage(section.single),
								}}
							/>
							<div
								className={styles.value}
								style={{
									top: getPercentage(section.single),
									right: `${i % 2 === 0 ? 10 : 25}%`,
								}}
							>
								{section.single.toUpperCase()}
							</div>
						</React.Fragment>
					);
				} else {
					const top = getPercentage(section.from);
					const bottom = getPercentage(section.to);

					return (
						<React.Fragment key={i}>
							<div
								className={styles.value}
								style={{
									top,
									left: '10%',
									// left: `${i % 2 === 0 ? 10 : 25}%`,
								}}
							>
								{section.from.toUpperCase()}
							</div>
							<div
								key={i}
								className={styles.range}
								style={{
									top: getPercentage(section.from),
									height: `calc(${bottom} - ${top})`,
								}}
							/>
							<div
								className={styles.value}
								style={{
									top: bottom,
									right: `${i % 2 === 0 ? 10 : 25}%`,
								}}
							>
								{section.to.toUpperCase()}
							</div>
						</React.Fragment>
					);
				}
			})}
		</div>
	);
}
